let allAddressPromise = null;

/**
 * Cây tỉnh/xã-phường (2 cấp) tĩnh: [{ id, name, Wards: [{ id, name }] }].
 * Tách thành chunk riêng, load bất đồng bộ và chỉ load 1 lần.
 */
export const getAllAddress = () => {
  if (!allAddressPromise) {
    allAddressPromise = import("../data/all-address.json")
      .then((module) => module.default)
      .catch((err) => {
        allAddressPromise = null;
        throw err;
      });
  }
  return allAddressPromise;
};
